import ContentService from "./ContentService";
import AWSContentService from "./AWSContentService";
import BackendContentNavigator from "./BackendContentNavigator";
import ContentNavigator from "./ContentNavigator";

export default class ContentServiceProvider {
  private static contentService: ContentService | null = null;
  private static contentNavigator: ContentNavigator | null = null;

  static getContentService: () => ContentService = () => {
    if (ContentServiceProvider.contentService === null) {
      ContentServiceProvider.contentService = new AWSContentService();
    }
    return ContentServiceProvider.contentService;
  };

  static getContentNavigator: () => ContentNavigator = () => {
    if (ContentServiceProvider.contentNavigator === null) {
      ContentServiceProvider.contentNavigator = new BackendContentNavigator();
    }
    return ContentServiceProvider.contentNavigator;
  };
}
